import { communication_callback } from 'communication_engagement'

// Step 1: Create a new EventTarget
export const customEventTarget = new EventTarget()

// Step 3: Create a function that will be called when the custom event is triggered
export async function handleCustomEvent(event) {
    await communication_callback(event)
}
